import React, { useEffect, useRef, useState } from "react";

const UserContext = React.createContext();

function UserContextProvider({ children }) {
  const [user, setUser] = useState();
  const [userLoading, setUserLoading] = useState(true);
  
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        setUserLoading,
        userLoading
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export { UserContext, UserContextProvider };
